import { FormaPagamentoType } from "services/formaPagamentoService";

// Definição dos itens de navegação (breadcrumb)
export const formasPagamentoBreadcrumbItems = [
  { label: "Cadastros", to: "/cadastros" },
  {
    label: "Formas de Pagamento",
    active: true,
  }
];

// Interfaces para comunicação com a API
export interface FormaPagamentoApiResponse {
  data: FormaPagamentoType[];
  isSuccess: boolean;
  message: string;
  total?: number;
  pageNumber?: number;
  pageSize?: number;
}

// Tipos de forma de pagamento
export const tiposFormaPagamento = [
  { value: 0, label: 'Dinheiro' },
  { value: 1, label: 'Cartão de Crédito' },
  { value: 2, label: 'Cartão de Débito' },
  { value: 3, label: 'Cheque' },
  { value: 4, label: 'Boleto' },
  { value: 5, label: 'Transferência Bancária' },
  { value: 6, label: 'Crediário' },
  { value: 7, label: 'PBM' },
  { value: 8, label: 'Convênio' },
  { value: 9, label: 'Outros' },
  { value: 10, label: 'Devolução' },
  { value: 11, label: 'PIX' },
];

// Mapear tipos de pagamento para descrições legíveis
export const tiposFormaPagamentoDisplay: { [key: string]: string } = {
  'Dinheiro': 'Dinheiro',
  'CartaoCredito': 'Cartão de Crédito', 
  'CartaoDebito': 'Cartão de Débito',
  'Cheque': 'Cheque',
  'Boleto': 'Boleto',
  'TransferenciaBancaria': 'Transferência Bancária',
  'Crediario': 'Crediário',
  'PBM': 'PBM',
  'Convenio': 'Convênio',
  'Outros': 'Outros',
  'Devolucao': 'Devolução',
  'PIX': 'PIX'
};

// Mapear strings para números
export const tipoStringToNumber: { [key: string]: number } = {
  'Dinheiro': 0,
  'CartaoCredito': 1,
  'CartaoDebito': 2,
  'Cheque': 3,
  'Boleto': 4,
  'TransferenciaBancaria': 5,
  'Crediario': 6,
  'PBM': 7,
  'Convenio': 8,
  'Outros': 9,
  'Devolucao': 10,
  'PIX': 11,
};

// Interface para os filtros ativos
export interface ActiveFilters {
  formaPagamentoStatus: string; // 'active', 'deleted', 'all'
}

// Interface para o estado de filtros consolidado
export interface FilterState {
  active: ActiveFilters;
  pending: ActiveFilters | null;
  filtersPending: boolean;
} 